import Marquee from "react-fast-marquee";

const ITEMS = [
  "Storkjøkken",
  "Vaskeri",
  "Skyllerom",
  "Institusjon",
  "Electrolux Professional",
  "Service i hele Midt-Norge",
];

export const Ribbon = ({ dark = false }) => (
  <div
    className={`py-5 border-y overflow-hidden ${dark ? "bg-ink border-white/10" : "bg-redx border-transparent"}`}
    data-testid="marquee-ribbon"
  >
    <Marquee speed={40} gradient={false}>
      {ITEMS.concat(ITEMS).map((t, i) => (
        <span key={i} className="marquee-item font-oswald uppercase text-2xl sm:text-4xl tracking-tight text-white mx-8">
          {t}
          <span className="mx-8 text-white/50">✳</span>
        </span>
      ))}
    </Marquee>
  </div>
);
